/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditBlockedTimeDialog/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import TimegridScheduleNote from 'DesignSystem/TimegridScheduleNote/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EditBlockedTimeDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/BlockedTime/EditBlockedTimeDialog",
  contentRef,
  top,
  left,
  onClose
  
}) {
let eventShowEditDialogValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'show_edit_dialog',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let eventScheduleNoteValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'schedule_note',
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={eventShowEditDialogValueData}>
<div
  data-testid="EditBlockedTimeDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 style={{'--t-1-RJXG': typeof top === 'number' ? `${top}px` : top,'--l-2-RJXG': typeof left === 'number' ? `${left}px` : left,'--bc-3-RJXG': dtColorsWhite,'--pl-4-RJXG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-5-RJXG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-6-RJXG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-7-RJXG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-RJXG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-9-RJXG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-10-RJXG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-11-RJXG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-12-RJXG': dtColorsNeutral200,'--g-13-RJXG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<TimegridScheduleNote
  viewPath={`${viewPath}/TimegridScheduleNote`}
 data="event.schedule_note"
 schedule_note={eventScheduleNoteValueData}
 onComplete={onClose}
/>
</div>
</fromFlow.When>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}